import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const NotificationBadge = ({ count, className = '', pulse = true }) => {
  if (count === 0) return null;

  const displayCount = count > 99 ? '99+' : count;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0 }}
        className={`notification-badge ${pulse ? 'pulse-animation' : ''} ${className}`}
      >
        <span className="notification-badge-text">{displayCount}</span>
      </motion.div>
    </AnimatePresence>
  );
};

export default NotificationBadge;
